import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

// Preenchimento pelo primeiro horário livre do doutor, logo abaixo da data e do horário: a busca, a data que mudou ou o
// dia sem horário livre (com o próximo, para usar com um clique)
function content(nextSlot) {
  if (nextSlot.state === 'loading')
    return <small className='d-flex align-items-center gap-1 text-muted'><Spinner animation='border' size='sm' /> Buscando o primeiro horário livre do doutor…</small>;

  if (!nextSlot.note) return null;

  return (
    <small className={`d-block ${nextSlot.state === 'failed' ? 'text-danger' : 'text-muted'}`}>
      {nextSlot.note}
      {nextSlot.suggestion ? (
        <>
          {' '}
          <Button variant='link' size='sm' className='p-0 align-baseline' onClick={nextSlot.applySuggestion}>Usar este horário</Button>
        </>
      ) : ''}
    </small>
  );
}

const NextSlotNote = ({ nextSlot }) => {
  const situation = content(nextSlot);

  return <div aria-live='polite' className={situation ? 'mb-2' : undefined}>{situation}</div>;
};

export default NextSlotNote;
